import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccessibilityDialogComponent } from '../../dialogs/accessibility-dialog/accessibility-dialog.component';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss']
})
export class AccessibilityComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }

  openaccessibilityDialog() {
    this.dialog.open(AccessibilityDialogComponent);
  }
}
